import React, { useMemo, useState } from "react";
import { Col, Container, Row, Button, Form, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Shoporder } from "Components/ShopTopBar";
import DeleteModal, { ModalAdd } from "Components/DeleteModal";
import {
  useDeleteStoreAddressMutation,
  useGetStoreMyAddressesQuery,
  useSetDefaultStoreAddressMutation,
} from "../../redux/services/store/storeAccountApi";
import { useGetStoreCartQuery } from "../../redux/services/store/storeCartApi";

const toNum = (v: any) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const Selectaddress = () => {
  document.title = "Shop | Select address | Toner - React FrontEnd";

  const location = useLocation();
  const fromCheckout = location.state?.from === "checkout";

  const { data, isLoading, isFetching, isError } = useGetStoreMyAddressesQuery();
  const [deleteStoreAddress] = useDeleteStoreAddressMutation();
  const [setDefaultStoreAddress] = useSetDefaultStoreAddressMutation();

  const { data: cartData } = useGetStoreCartQuery();

  const [id, setId] = useState<number | null>(null);
  const [removeModel, setRemovemodel] = useState(false);
  const [addressModal, setAddressModal] = useState(false);
  const [editAddress, setEditAddress] = useState<any>(null);

  const RemoveModel = (addressId?: number | null) => {
    if (addressId !== undefined && addressId !== null) {
      setId(addressId);
      setRemovemodel(true);
      return;
    }
    setRemovemodel(false);
  };

  const deleteData = async () => {
    if (!id) return;
    try {
      await deleteStoreAddress(id).unwrap();
      setRemovemodel(false);
      setId(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = () => {
    setAddressModal(false);
    setEditAddress(null);
  };

  const handleShowAdd = () => {
    setEditAddress(null);
    setAddressModal(true);
  };

  const handleShowEdit = (address: any) => {
    setEditAddress(address);
    setAddressModal(true);
  };

  const addresses = useMemo(() => {
    const rows = Array.isArray(data) ? data : [];
    return rows.filter((item: any) => !!item?.is_active);
  }, [data]);

  const selectedShippingId = useMemo(() => {
    const selected = addresses.find((item: any) => item?.is_default_shipping);
    return selected?.id ?? null;
  }, [addresses]);

  const handleSelectDefault = async (addressId: number) => {
    try {
      await setDefaultStoreAddress({
        address_id: addressId,
        kind: "shipping",
      }).unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  const getAddressBadge = (item: any) => {
    if (item?.label) return item.label;
    if (item?.address_type === "billing") return "Billing";
    if (item?.address_type === "shipping") return "Shipping";
    return item?.address_type || "Address";
  };

  const getAddressLine = (item: any) => {
    return [item?.line1, item?.line2, item?.landmark, item?.city, item?.state, item?.postal_code]
      .filter(Boolean)
      .join(", ");
  };

  const currency = (cartData as any)?.cart?.currency_code || "USD";
  const subtotal = toNum((cartData as any)?.totals?.subtotal);
  const discount = toNum((cartData as any)?.totals?.discount);
  const tax = toNum((cartData as any)?.totals?.tax);
  const charge =
    (cartData as any)?.totals?.shipping != null ? toNum((cartData as any)?.totals?.shipping) : 0;
  const total =
    (cartData as any)?.totals?.total != null
      ? toNum((cartData as any)?.totals?.total)
      : subtotal + charge + tax - discount;

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row>
            <Col xl={8}>
              <div>
                <h4 className="fs-18 mb-4">Select or add an address</h4>

                <Row className="g-4" id="address-list">
                  {isError ? (
                    <Col xs={12}>
                      <div className="text-danger">Failed to load addresses</div>
                    </Col>
                  ) : isLoading || isFetching ? (
                    <Col xs={12}>
                      <div className="text-center py-4">
                        <Spinner animation="border" size="sm" /> Loading...
                      </div>
                    </Col>
                  ) : addresses.length === 0 ? (
                    <Col xs={12}>
                      <div className="text-muted">No address found</div>
                    </Col>
                  ) : (
                    addresses.map((item: any, index: number) => {
                      const inputId = `shippingAddress-${item.id}-${index}`;
                      const checked = selectedShippingId === item.id;

                      return (
                        <Col lg={6} key={item.id}>
                          <div>
                            <div className="form-check card-radio">
                              <Form.Control
                                id={inputId}
                                name="shippingAddress"
                                type="radio"
                                className="form-check-input"
                                checked={checked}
                                onChange={() => handleSelectDefault(item.id)}
                              />
                              <Form.Label className="form-check-label" htmlFor={inputId}>
                                <span className="mb-4 fw-semibold fs-12 d-block text-muted text-uppercase">
                                  {getAddressBadge(item)}
                                </span>
                                <span className="fs-14 mb-2 fw-semibold d-block">
                                  {item?.contact_name}
                                </span>
                                <span className="text-muted fw-normal text-wrap mb-1 d-block">
                                  {getAddressLine(item)}
                                </span>
                                <span className="text-muted fw-normal d-block">
                                  Mo. {item?.mobile_e164 || "-"}
                                </span>
                              </Form.Label>
                            </div>

                            <div className="d-flex flex-wrap p-2 py-1 bg-light rounded-bottom border mt-n1 fs-13">
                              <div>
                                <Link
                                  to="#"
                                  className="d-block text-body p-1 px-2 edit-list"
                                  data-edit-id={item.id}
                                  data-bs-toggle="modal"
                                  data-bs-target="#addAddressModal"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleShowEdit(item);
                                  }}
                                >
                                  <i className="ri-pencil-fill text-muted align-bottom me-1"></i>
                                  Edit
                                </Link>
                              </div>
                              <div>
                                <Link
                                  to="#"
                                  className="d-block text-body p-1 px-2 remove-list"
                                  data-remove-id={item.id}
                                  data-bs-toggle="modal"
                                  data-bs-target="#removeAddressModal"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    RemoveModel(item.id);
                                  }}
                                >
                                  <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i>{" "}
                                  Remove
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      );
                    })
                  )}
                </Row>

                <Row className="mt-4">
                  <Col lg={6}>
                    <div className="text-center p-4 rounded-3 border border-2 border-dashed">
                      <div className="avatar-md mx-auto mb-4">
                        <div className="avatar-title bg-success-subtle text-success rounded-circle display-6">
                          <i className="bi bi-house-add"></i>
                        </div>
                      </div>
                      <h5 className="fs-16 mb-3">Add New Address</h5>
                      <Button
                        variant="success"
                        className="btn-sm w-xs stretched-link addAddress-modal"
                        data-bs-toggle="modal"
                        data-bs-target="#addAddressModal"
                        onClick={handleShowAdd}
                      >
                        Add
                      </Button>
                    </div>
                  </Col>
                </Row>

                <div className="hstack gap-2 justify-content-start mt-3">
                  {fromCheckout ? (
                    <Link
                      to="/shop/checkout"
                      state={{ from: "checkout" }}
                      className="btn btn-danger btn-hover"
                    >
                      Back to Checkout
                    </Link>
                  ) : (
                    <Link to="/" className="btn btn-danger btn-hover">
                      Continue Shopping
                    </Link>
                  )}
                </div>
              </div>
            </Col>

            <Col xl={4}>
              <div className="sticky-side-div">
                <Shoporder
                  subtotal={subtotal}
                  dic={discount}
                  charge={charge}
                  tax={tax}
                  total={total}
                  currency={currency}
                />
              </div>
            </Col>
          </Row>

          <DeleteModal removeModel={removeModel} hideModal={RemoveModel} deleteData={deleteData} />
          <ModalAdd
            addressModal={addressModal}
            handleClose={handleClose}
            editAddress={editAddress}
          />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Selectaddress;
